<template>
  <div v-if="npc" class="person" :class="`person--${name}`" :style="`--npcwidth: ${npc.Width}px; --npcbottom: ${npc.Bottom}px;`">
    <div v-if="hasSprites" class="person__container">
      <div class="person__inner">
        <!-- stand (right) -->
        <img
          v-for="count in 4"
          :key="`ls-${count - 1}`"
          :alt="name"
          :src="npc.RightStand[count - 1] ? npc.RightStand[count - 1] : npc.RightStand[0]"
        >
      </div>
    </div>
    <div v-if="speechbubble" class="speechbubble">
      {{ speechbubble }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorldNpc1',

  props: {
    speechbubble: {
      default: () => '',
      type: String
    },
    npcs: {
      default: () => {},
      type: [Array, Object]
    }
  },

  computed: {
    npc () {
      if (this.npcs) {
        return this.npcs
      }
      return null
    },
    hasSprites () {
      if (this.npc) {
        if (
          this.npc.RightStand.length > 2
        ) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      name: 'npc'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

.speechbubble {
  z-index: 5;
  bottom: 75%;
  left: 35%;
  width: 120px;
}

$delay: 2.5s;
$duration: 1s;
.person--npc {
  display: none;
  bottom: 54px;
  bottom: calc(78px - var(--npcbottom));
  right: 5%;
  width: 0;
  width: var(--npcwidth);
  overflow: visible;
  transform: scale(.8);

  @include breakpointHeight(730px) {
    display: block;
  }
  @include breakpointHeight(750px) {
    transform: scale(1);
  }
  @include breakpoint(430px) {
    display: none;
    transform: scale(1);
    bottom: 62px;
    bottom: calc(86px - var(--npcbottom));

    @include breakpointHeight(800px) {
      display: block;
    }
  }
  @include breakpoint(sm) {
    display: none;

    @include breakpointHeight(900px) {
      display: block;
    }
  }
  @include breakpoint(md) {
    display: block;
    right: auto;
  }
  @include breakpoint(lg) {
    display: block;
    left: calc(50% - 480px);

    @include breakpointHeight(850px) {
      left: calc(50% + 220px);
      bottom: 624px;
      bottom: calc(648px - var(--npcbottom));
      padding-bottom: 0;
    }
    @include breakpointHeight(920px) {
      bottom: 698px;
      bottom: calc(722px - var(--npcbottom));
      left: calc(50% + 300px);
    }
  }

  .person__inner {
    transform: translate3d(0, 0, 0);
    animation: npc-animate $duration steps(1) infinite $delay;

    img {
      width: var(--npcwidth);
      min-width: var(--npcwidth);
    }
  }
}
@keyframes npc-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  33.333% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  66.666% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  100% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
}
</style>
